import TimelineItemModel from './TimelineItemModel';

const TimelineElementModel = {
  elements: [TimelineItemModel],
};

export default TimelineElementModel;
